import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { takePostLoginPath } from '../../utils/postLoginRedirect';

/**
 * After Auth0 sign-in, sends the user to the page they were trying to open
 * (see utils/postLoginRedirect). Renders nothing; mount it once inside the
 * Router.
 */
export const PostLoginRedirect: React.FC = () => {
  const { isAuthenticated, isLoading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (isLoading || !isAuthenticated) return;
    const path = takePostLoginPath();
    if (path) {
      navigate(path, { replace: true });
    }
  }, [isAuthenticated, isLoading, navigate]);

  return null;
};

export default PostLoginRedirect;
